import { Slider, Typography, Stack, useTheme, TextField } from "@mui/material";
import { Strings } from "@app/constants";
import { RangeSliderProps } from "../../types";

const RangeSlider = ({
  title,
  min,
  max,
  step = 1,
  value,
  onChange,
}: RangeSliderProps) => {
  const theme = useTheme();

  const handleInputChange = (index: number, newValue: string) => {
    const numericValue = Number(newValue);
    if (!isNaN(numericValue)) {
      const updated = [...value];
      updated[index] = numericValue;

      if (updated[0] < min) updated[0] = min;
      if (updated[1] > max) updated[1] = max;

      if (updated[0] > updated[1]) updated[0] = updated[1];

      onChange?.(null as any, updated);
    }
  };

  return (
    <Stack spacing={1} sx={{ width: "100%" }}>
      <Typography variant="subtitle1">{title}</Typography>

      <Stack direction="row" justifyContent="space-between" gap={2}>
        <TextField
          size="small"
          type="number"
          value={value[0]}
          onChange={(e) => handleInputChange(0, e.target.value)}
          inputProps={{ min, max, step }}
          sx={{ width: "45%" }}
          label={Strings.filters.min}
        />
        <TextField
          size="small"
          type="number"
          value={value[1]}
          onChange={(e) => handleInputChange(1, e.target.value)}
          inputProps={{ min, max, step }}
          sx={{ width: "45%" }}
          label={Strings.filters.max}
        />
      </Stack>

      <Stack sx={{ flexDirection: "row", justifyContent: "space-between" }}>
        <Typography sx={{ color: theme.palette.primary.main }}>
          ₹{value[0]?.toLocaleString()}
        </Typography>
        <Typography sx={{ color: theme.palette.primary.main }}>
          ₹{value[1]?.toLocaleString()}
        </Typography>
      </Stack>

      <Slider
        value={value}
        onChange={onChange}
        valueLabelDisplay="auto"
        min={min}
        max={max}
        step={step}
        sx={{
          "& .MuiSlider-thumb": { color: theme.palette.primary.main },
          "& .MuiSlider-track": { color: theme.palette.primary.main },
          "& .MuiSlider-rail": { color: theme.palette.primary.main },
          height: 4,
        }}
      />
    </Stack>
  );
};

export { RangeSlider };
